import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog, Floating } from 'components';
import { dialogs } from 'features/views/roboAdvisory/roboAdvisoryHandover/constants';

import CheckedAnalysisTable from './CheckedAnalysisTable';
import Form from './Form';

export const RAHandoverModalBody = () => {
	return (
		<>
			<Floating>
				<Dialog mui name={dialogs.NO_SUBORDINATE_TO_HANDOVER}>
					{getLabelMessage('roboAdvisory:handOverModalNoSubordinate')}
				</Dialog>
			</Floating>
			<Stack spacing={3}>
				<CheckedAnalysisTable />
				<Form />
			</Stack>
		</>
	);
};

RAHandoverModalBody.propTypes = {
	handleHandOver: PropTypes.func,
};

export default RAHandoverModalBody;
